import { render, staticRenderFns } from "./dashboardTab.vue?vue&type=template&id=d13d8702&scoped=true&lang=html&"
import script from "./dashboardTab.vue?vue&type=script&lang=js&"
export * from "./dashboardTab.vue?vue&type=script&lang=js&"
import style0 from "./dashboardTab.vue?vue&type=style&index=0&id=d13d8702&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13d8702",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VDivider,VProgressLinear})
